// =============================================================================
// src/data/ai-surfaces/section-insight-surfaces.ts — Insights de IA por seção.
//
// Cards de insight injetados no topo das seções do feed + cards específicos
//   (demográfica, perfil-região, negócios). Todos ← gold.section_insight (Camada 3,
//   MiniMax M3), consumidos por insights-client.ts#toInsight via ctx.sectionInsights.
// =============================================================================

import type { AiSurfaceEntry } from '../ai-surface-types';

export const SECTION_INSIGHT_AI_SURFACES: readonly AiSurfaceEntry[] = [
  {
    id: 'section-insight.feed-cards',
    label: 'Cards de insight no feed',
    domain: 'section-insight',
    location: 'Topo de cada seção do feed (#contentCol)',
    renderRef: 'src/views/shared/section-insight-card.ts#renderSectionInsightCard',
    aiKind: 'insight',
    backendLayer: 'camada-3',
    backendSource: { kind: 'hasura-table', name: 'gold.section_insight' },
    status: 'live',
    inputs: ['snapshot 24h por seção', 'evidence_ids'],
    fields: [
      { uiField: 'insight.label', backendField: 'label', type: 'string' },
      { uiField: 'insight.headline', backendField: 'headline', type: 'string' },
      { uiField: 'insight.detail', backendField: 'detail', type: 'string' },
      { uiField: 'insight.confidence', backendField: 'confidence', type: 'percent' },
      { uiField: 'insight.primary', backendField: 'primary_label', type: 'string' },
      { uiField: 'insight.primaryPrompt', backendField: 'primary_prompt', type: 'string' },
      { uiField: 'insight.why', backendField: 'why', type: 'string' },
    ],
  },
  {
    id: 'section-insight.demografica',
    label: 'Insight demográfico',
    domain: 'section-insight',
    location: 'Seção Demográfica · #u-demo-insight',
    renderRef: 'src/views/demografica/demografica-template.ts#renderDemograficaSection',
    aiKind: 'insight',
    backendLayer: 'camada-3',
    backendSource: { kind: 'hasura-table', name: 'gold.section_insight' },
    status: 'mock',
    inputs: ['recorte demográfico', 'afinidade partidária por segmento'],
    fields: [
      { uiField: 'demo.insight.headline', backendField: 'headline', type: 'string' },
      { uiField: 'demo.insight.detail', backendField: 'detail', type: 'string' },
    ],
  },
  {
    id: 'section-insight.perfil-regiao',
    label: 'Cards do perfil da região',
    domain: 'section-insight',
    location: 'Seção Perfil da Região · 4 cards (eleições/demo/influências/negócios)',
    renderRef: 'src/views/perfil-regiao/perfil-regiao-insights.ts#PERFIL_INSIGHT_CARDS',
    aiKind: 'insight',
    backendLayer: 'camada-3',
    backendSource: { kind: 'hasura-table', name: 'gold.section_insight' },
    status: 'mock',
    inputs: ['padrões cruzados (eleitoral × demográfico × econômico)'],
    fields: [
      { uiField: 'perfil.card.titulo', backendField: 'label', type: 'string' },
      { uiField: 'perfil.card.texto', backendField: 'detail', type: 'string' },
    ],
  },
  {
    id: 'section-insight.negocios',
    label: 'Narrativas de modo (Negócios)',
    domain: 'section-insight',
    location: 'Seção Negócios · #u-neg-insight-text',
    renderRef: 'src/views/negocios/negocios-controller.ts#NEGOCIOS_INSIGHT_BASE',
    aiKind: 'insight',
    backendLayer: 'camada-3',
    backendSource: { kind: 'hasura-table', name: 'gold.section_insight' },
    status: 'mock',
    inputs: ['densidade de CNPJs por zona', 'setor dominante'],
    fields: [
      { uiField: 'neg.insight.texto', backendField: 'detail', type: 'string' },
    ],
  },
];
